define([
        'components/selectize', 
        'core/browser-storage',
        'components/daterangepicker',
        'core/iterate'
    ], function (
        selectize_util, 
        browser_storage,
        drp,
        iterate,
    ) 
{
    let nodes = {
        pageHeader: document.querySelector(".page-header.filters-icon-wrap"),
        filterSettingsToggle: document.querySelector(".settings-toggle-wrap"),
        filterSettingsToggleLabel: document.querySelector(".settings-toggle-wrap .label"),
        filterSettings: document.querySelector(".filter-settings"),
    }

    nodes.pageHeader.addEventListener("click", () => {
        nodes.filterSettingsToggle.classList.contains("active") ? nodes.filterSettingsToggle.classList.remove("active") : nodes.filterSettingsToggle.classList.add("active");
        nodes.filterSettings.classList.contains("hide") ? nodes.filterSettings.classList.remove("hide") : nodes.filterSettings.classList.add("hide");
        
        if (nodes.filterSettings.classList.contains("hide")) {
            nodes.filterSettingsToggleLabel.innerText = "Show Filters";
        } else {
            nodes.filterSettingsToggleLabel.innerText = "Hide Filters";
        }
    })

    let reviewFields = JSON.parse(document.querySelector("#reviewFields").innerText);
    let renderedFilters = document.querySelectorAll(".csat-filters [data-filter-name]");

    let filtersToInclude = reviewFields.filter(field => field.filterable).map(field => field.id);

    renderedFilters.forEach(filter => {
        let filterName = filter.dataset.filterName;
        
        if(filtersToInclude.indexOf(filterName) < 0) {
            filter.remove();
        }
    })

    const setSettingsHeight = (isPageLoad) => {
        let isHidden = nodes.filterSettings.classList.contains("hide");
        //disable transitions while adjusting height value
        nodes.filterSettings.classList.add("no-transition");
        // momentarily show and save settings height so hide transition works
        nodes.filterSettings.classList.remove("hide");
        nodes.filterSettings.style.height = null;
        let settingsHeight = nodes.filterSettings.offsetHeight;
        nodes.filterSettings.style.height = `${settingsHeight}px`;
    
        if(isPageLoad || isHidden) { // don't override user's open/close settings
            nodes.filterSettings.classList.add("hide");
        }
            
        setTimeout(() => {
            nodes.filterSettings.classList.remove("no-transition");
        }, 500);
    }

    window.addEventListener('resize', () => {setSettingsHeight()});

    setSettingsHeight(true);

    return class FilterBox {
        constructor(prefix, mode, onChange, onReset=null) {
            drp.create({}, () => {
                drp.saveToBrowserStorage(`${prefix}-filters`);
                onChange(this.getFilterData());
                this.updateFilterStatus();
            });
            drp.loadFromBrowserStorage(`${prefix}-filters`);

            this.prefix = prefix;
            this.mode = mode;

            if (mode == 'review') {
                this.buttonSentimentPositiveOn = $('#button-sentiment-positive-on');
                this.buttonSentimentPositiveOff = $('#button-sentiment-positive-off');
                this.buttonSentimentNeutralOn = $('#button-sentiment-neutral-on');
                this.buttonSentimentNeutralOff = $('#button-sentiment-neutral-off');
                this.buttonSentimentNegativeOn = $('#button-sentiment-negative-on');
                this.buttonSentimentNegativeOff = $('#button-sentiment-negative-off');

                this.buttonSentimentPositiveOn.click(this.buildSentimentFilterClickHandler(this.buttonSentimentPositiveOn, this.buttonSentimentPositiveOff));
                this.buttonSentimentPositiveOff.click(this.buildSentimentFilterClickHandler(this.buttonSentimentPositiveOff, this.buttonSentimentPositiveOn));
                this.buttonSentimentNeutralOn.click(this.buildSentimentFilterClickHandler(this.buttonSentimentNeutralOn, this.buttonSentimentNeutralOff));
                this.buttonSentimentNeutralOff.click(this.buildSentimentFilterClickHandler(this.buttonSentimentNeutralOff, this.buttonSentimentNeutralOn));
                this.buttonSentimentNegativeOn.click(this.buildSentimentFilterClickHandler(this.buttonSentimentNegativeOn, this.buttonSentimentNegativeOff));
                this.buttonSentimentNegativeOff.click(this.buildSentimentFilterClickHandler(this.buttonSentimentNegativeOff, this.buttonSentimentNegativeOn));

                if(filtersToInclude.indexOf("status") > -1) {
                    this.statusFilterWidget = selectize_util.safeInstance($('#status-filter'));
                }
            }

            // selectize filters
            filtersToInclude.forEach(filterName => {
                let filterElement = $(`#${filterName}-filter`);
                if(filterElement.length) {
                    this[`${filterName}FilterWidget`] = selectize_util.safeInstance(filterElement);
                }
            
            })

            this.reactionDetailsTagsWidget = selectize_util.optionalInstance($('#reaction-details-tags'));

            this.onChange = () => {
                // this.saveFilter();
                onChange(this.getFilterData());
                this.updateFilterStatus();
            };
            
            $('#clear-filter').on('click', () => {
                if (onReset) {
                    onReset();
                    this.clear();
                    this.updateFilterStatus();
                }
            });

            $('#close-filter').on('click', () => {
                this.setFilterOpenedClosedState();
                this.updateFilterStatus();
            });

            $('#open-filter').on('click', () => {
                $(window).scrollTop(0); // scroll to top
                this.setFilterOpenedClosedState();
                this.updateFilterStatus();
            });

            this.restore();

            $('.filter-box').on('change', this.onChange);
        }

        buildSentimentFilterClickHandler(tohide, toshow) {
            return () => {
                tohide.addClass('hide');
                toshow.removeClass('hide');
                this.onChange();
            };
        }

        setPersistentValue(name, value) {
            if(value) {
                browser_storage.setItem(this.prefix + '-' + name, value);
            } else {
                browser_storage.removeItem(this.prefix + '-' + name);
            }
        }

        updateFilterStatus() {
            let filters = this.getFilterData();
    
            // construct contextual messaging for filter status bar
            let activeCategories = [];
            let filterCount = 0;
    
            iterate(filters, (value, key) => {
                if(typeof(value) === 'object' && value.length > 0) {
                    filterCount += value.length;
                    activeCategories.push(key)
                }
    
                if(key === 'comments' && value !== 'all') {
                    filterCount ++;
                    activeCategories.push(key);
                }
            })
    
            let filterStatus = document.querySelector(".filter-status");
            let message = "No filters selected";
    
            if(activeCategories.length > 0) {
                let buildCategoryGrammar = () => {
                    if(activeCategories.length === 1) return `<strong class="category-name">${activeCategories.toString()}</strong>`;
                    
                    let oxfordComma = activeCategories.length === 2 ? ' ' : ', ';
                    let lastCategory = activeCategories.pop();
                    return `<strong class="category-name">${activeCategories.join('</strong>, <strong class="category-name">')}</strong>${oxfordComma}and <strong class="category-name">${lastCategory}</strong>`;
                }
                
                let categoryText = activeCategories.length < 4 ? buildCategoryGrammar() : `<strong>${activeCategories.length} categories</strong>`
                let filterText = filterCount > 1 ? 'filters' : 'filter';
    
                message = `<strong>${filterCount}</strong> active ${filterText} in ${categoryText}`
    
                filterStatus.classList.add("active")
            } else {
                filterStatus.classList.remove("active")
            }
    
            filterStatus.innerHTML = message;

            // construct date string for status bar
            let dateStatus = document.querySelector(".status-wrap .date-range .value");
        
            if(drp.getPreset()) {
                dateStatus.innerHTML = drp.getPreset().toLowerCase();
            } else {
                dateStatus.innerHTML = `${drp.getStartDate().format('MMM DD, YYYY')} - ${drp.getEndDate().format('MMM DD, YYYY')}`;
            }
    
            setSettingsHeight();
        }

        getFilterData() {
            let data = {};

            if(this.buttonSentimentPositiveOn) {
                data['ratings'] = [];
                if (!this.buttonSentimentPositiveOn.hasClass('hide')) {
                    data['ratings'].push(1);
                }
                if (!this.buttonSentimentNeutralOn.hasClass('hide')) {
                    data['ratings'].push(0);
                }
                if (!this.buttonSentimentNegativeOn.hasClass('hide')) {
                    data['ratings'].push(-1);
                }
            }
            
            if (this.companyFilterWidget && this.companyFilterWidget.getValue()) {
                data['companies'] = this.companyFilterWidget.getValue();
            }
            if (this.agentsFilterWidget && this.agentsFilterWidget.getValue()) {
                data['agents'] = this.agentsFilterWidget.getValue();
            }
            if (this.segmentFilterWidget && this.segmentFilterWidget.getValue()) {
                data['segments'] = this.segmentFilterWidget.getValue();
            }
            if(this.mode == "review") {
                if (this.statusFilterWidget && this.statusFilterWidget.getValue()) {
                    data['statuses'] = this.statusFilterWidget.getValue();
                }
            }
            if (this.tagsFilterWidget && this.tagsFilterWidget.getValue()) {
                data['tags'] = this.tagsFilterWidget.getValue();
            }
            
            if (this.commentsFilterWidget && this.commentsFilterWidget.getValue()) {
                data['comments'] = this.commentsFilterWidget.getValue();
            }

            if (this.marketsFilterWidget && this.marketsFilterWidget.getValue()) {
                data['markets'] = this.marketsFilterWidget.getValue();
            }

            if (this.territoriesFilterWidget && this.territoriesFilterWidget.getValue()) {
                data['territories'] = this.territoriesFilterWidget.getValue();
            }

            if (this.groupsFilterWidget && this.groupsFilterWidget.getValue()) {
                data['groups'] = this.groupsFilterWidget.getValue();
            }

            data['start_date'] = drp.getStartDate().format("YYYY-MM-DD");
            data['end_date'] = drp.getEndDate().format("YYYY-MM-DD");

            return data;
        }

        updateTags(tags){
            $.each(tags, (index, value) => {
                this.tagsFilterWidget.addOption({text: value, value: value});
            });
        }

        updateAgents(agents){
            $.each(agents, (index, value) => {
                this.agentsFilterWidget.addOption({text: value, value: value});
            });
        }

        saveFilter() {
            let data = this.getFilterData();
            this.setPersistentValue('companies', JSON.stringify(data['companies']));
            this.setPersistentValue('agents', JSON.stringify(data['agents']));
            this.setPersistentValue('segments', JSON.stringify(data['segments']));
            this.setPersistentValue('statuses', JSON.stringify(data['statuses']));
            this.setPersistentValue('tags', JSON.stringify(data['tags']));
            let showpositive = !this.buttonSentimentPositiveOn.hasClass('hide'),
                showneutral = !this.buttonSentimentNeutralOn.hasClass('hide'),
                shownegative = !this.buttonSentimentNegativeOn.hasClass('hide'),
                showcomments = this.commentsFilterWidget.getValue();

            // Some browsers store only strings
            this.setPersistentValue('positive', showpositive ? 'on' : 'off');
            this.setPersistentValue('neutral', showneutral ? 'on' : 'off');
            this.setPersistentValue('negative', shownegative ? 'on' : 'off');
            this.setPersistentValue('comments', showcomments);
        }

        parse_smile(sessionName, onWidget, offWidget) {
            // For sentiment filters, the standard state is to show the button. So we only need to react to 'off' state
            if(browser_storage.getItem(this.prefix + '-' + sessionName) == 'off') {
                onWidget.addClass('hide');
                offWidget.removeClass('hide');
            }
        }

        parse_select(sessionName, selectize) {
            var savedValue = browser_storage.getItem(this.prefix + '-' + sessionName),
                entryList = savedValue ? JSON.parse(savedValue) : undefined;
            if (entryList) {
                selectize.clear();
                entryList.forEach(function(entry) {
                    selectize.addItem(entry);
                });
            }
        }

        parse_single_select(sessionName, selectize) {
            let optionKey = browser_storage.getItem(this.prefix + '-' + sessionName);
            if (optionKey) {
                selectize.setValue(optionKey);
            }
        }


        restore() {
            this.parse_smile('positive', this.buttonSentimentPositiveOn, this.buttonSentimentPositiveOff);
            this.parse_smile('neutral', this.buttonSentimentNeutralOn, this.buttonSentimentNeutralOff);
            this.parse_smile('negative', this.buttonSentimentNegativeOn, this.buttonSentimentNegativeOff);

            this.parse_single_select('comments', this.commentsFilterWidget);
            this.parse_select('companies', this.companyFilterWidget);
            this.parse_select('agents', this.agentsFilterWidget);
            this.parse_select('segments', this.segmentFilterWidget);
            if (this.mode == 'review') {
                this.parse_select('statuses', this.statusFilterWidget);
            }
            this.parse_select('tags', this.tagsFilterWidget);
        }

        clear(){
            browser_storage.clearByPrefix(this.prefix);
            if(this.companyFilterWidget) this.companyFilterWidget.clear();
            if(this.agentsFilterWidget) this.agentsFilterWidget.clear();
            if(this.segmentFilterWidget) this.segmentFilterWidget.clear();
            if (this.mode == 'review') {
                this.statusFilterWidget.clear();
                this.buttonSentimentPositiveOff.removeClass('hide');
                this.buttonSentimentPositiveOn.addClass('hide');
                this.buttonSentimentNeutralOff.removeClass('hide');
                this.buttonSentimentNeutralOn.addClass('hide');
                this.buttonSentimentNegativeOff.removeClass('hide');
                this.buttonSentimentNegativeOn.addClass('hide');
            }
            if(this.tagsFilterWidget) this.tagsFilterWidget.clear();
            if(this.marketsFilterWidget) this.marketsFilterWidget.clear();
            if(this.territoriesFilterWidget) this.territoriesFilterWidget.clear();
            if(this.groupsFilterWidget) this.groupsFilterWidget.clear();
            if(this.commentsFilterWidget) this.commentsFilterWidget.setValue('all');
        }
    }
});
